import styled from 'styled-components';

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.primaryBase};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const MarginWrapper = styled.div`
  margin: 8px;
`;

export const VerticalSpacing = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const FlexRowSpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const FullWidthDiv = styled.div`
  width: 100%;
`;
